<script lang="ts">
  import type { ImageAsset } from '$lib/types/contentTypes';
  export let title: string;
  export let subHeading: string;
  export let image: ImageAsset;
  export let link: string;
  export let description: string | undefined = undefined;
</script>

<a href={link} class="flex gap-4 lg:block lg:gap-8">
  <div
    class="flex w-[142px] lg:w-full lg:max-h-[15rem] lg:mb-6 aspect-[6/5] rounded-xxl overflow-hidden bg-[#f1f0ef]"
  >
    <img
      src="{image.url}?w=600&q=85&fm=webp"
      alt={image.title}
      class="object-cover self-center w-full h-full mb-[-1px] mix-blend-multiply"
    />
  </div>

  <div class="flex flex-col w-2/3 gap-0 justify-center lg:w-auto lg:gap-1">
    <p class=" text-primary-500 font-semibold text-xs lg:text-sm">{subHeading}</p>
    <h3 class="text-gray-900 font-semibold text-normal lg:text-xl">{title}</h3>
    {#if description}
      <p class=" text-gray-600 font-medium text-xs lg:text-md">{description}</p>
    {/if}
  </div>
</a>
